const config = {
  API_URL: process.env.API_URL || "http://localhost:3000",
  FIREBASE_CONFIG: {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
  },
  ENV: process.env.NODE_ENV || "development",
  endPoints: (() => {
    const baseUrl = process.env.BACKEND_URL;
    return {
      baseURL: baseUrl,
      stores: `${baseUrl}/stores`,
      storeByNodeId: `${baseUrl}/turnero/stores/node`,
      filters: `${baseUrl}/general/filters`,
      availableBUs: `${baseUrl}/stores/businessunits`,
      slots: `${baseUrl}/slots`,
      bookings: `${baseUrl}/bookingsv2`,
      latestbooking: `${baseUrl}/bookingsv2/latest`,
      qrdata: `${baseUrl}/bookingsv2/bookingIdPlaceholder/qr`,
      storeInsideMall: `${baseUrl}/stores/storeIdPlaceholder/mallstores`,
      perBuBookings: `${baseUrl}/bookingsv2/user`,
      queuesList: `${baseUrl}/queues/`,
      bookQueue: `${baseUrl}/queues/bookqueue`,
      tokenStatus: `${baseUrl}/queues/userIdPlaceholder/tokenstatus`,
      storeUser: `${baseUrl}/queues/storeUserIdPlaceholder/tokens`,
      currentAttention: `${baseUrl}/queues/storeIdPlaceholder/currentattention`,
      queueStatus: `${baseUrl}/queues/storeIdPlaceholder/queuestatus`,
      selfCheckIn: `${baseUrl}/bookings/bookingIdPlaceholder/updatestatus`,
      cancelBookings: `${baseUrl}/bookingsv2`,
      turneroStores: `${baseUrl}/turnero/stores`,
      turneroStoresActive: `${baseUrl}/turnero/stores/active`,
      firebasetoken: `${baseUrl}/stores/firebasetoken`,
      firebasetokens: `${baseUrl}/turnero/firebasetoken`,
    };
  })(),
  app_test_config: {
    country: process.env.TEST_COUNTRY || "TEST",
    bu: process.env.TEST_BU || "Test",
    source: process.env.TEST_SOURCE || "test",
  },
  shared_bu_user_detail: ["Banco Falabella", "IKEA", "Car Center"],
  showNoonSlotsBU: process.env.SHOW_NOON_SLOTS_BU || "Banco Falabella",
  bu_name_map: {
    falabellacom: "Falabella.com",
    falabella: "Falabella",
    carcenter: "Car Center",
    tottus: "Tottus",
    sodimac: "Sodimac",
    maestro: "Maestro",
    bancofalabella: "Banco Falabella",
    ikea: "IKEA",
    cmr: "CMR",
    hiperbodegapreciouno: "HiperBodegaPrecioUno",
    openplaza: "Openplaza",
    mallplaza: "Mallplaza",
    falabellatecnologia: "Falabella Tecnología",
  },
  turnero_enabled_bu_list: [
    "Sodimac",
    "Falabella",
    "Tottus",
    "Maestro",
    "Falabella.com",
  ],
  shared_platform_bu_list: ["Tottus"],
  stand_alone_bu_list: ["Mallplaza", "Openplaza"],
  phone_code_map: {
    CL: "56",
    PE: "51",
    AR: "54",
    BR: "55",
    IN: "91",
    MX: "52",
    CO: "57",
    UY: "598",
  },
  country_code_map: {
    chile: "CL",
    cl: "CL",
    pe: "PE",
    ar: "AR",
    mx: "MX",
    co: "CO",
    ur: "UY",
    br: "BR",
    peru: "PE",
    mexico: "MX",
    argentina: "AR",
    colombia: "CO",
    india: "IN",
    uruguay: "UY",
    brazil: "BR",
  },
  country_language_map: {
    chile: "es",
    peru: "es",
    mexico: "es",
    argentina: "es",
    colombia: "es",
    uruguay: "es",
    india: "en",
    brazil: "pt",
    default: "es",
    cl: "es",
    pe: "es",
    ar: "es",
    mx: "es",
    co: "es",
    ur: "es",
    br: "pt",
  },
  valid_source_list: [
    "test",
    "mallplaza_web",
    "openplaza_web",
    "sodimac_ios",
    "sodimac_android",
    "sodimac_web",
    "sodimac_totem",
    "carcenter_web",
    "bancofalabella_ios",
    "bancofalabella_android",
    "bancofalabella_web",
    "ikea_ios",
    "ikea_android",
    "ikea_web",
    "hiperbodegapreciouno_ios",
    "hiperbodegapreciouno_android",
    "hiperbodegapreciouno_web",
    "cmr_ios",
    "cmr_android",
    "cmr_web",
    "falabella_ios",
    "falabella_android",
    "falabella_web",
    "fazil_android",
    "fazil_ios",
    "tottus_web",
    "tottus_totem",
    "tottus_android",
    "tottus_ios",
    "msteams",
    "maestro_ios",
    "maestro_android",
    "maestro_web",
    "maestro_totem",
    "falabellacom_ios",
    "falabellacom_android",
    "falabellacom_web",
    "falabella_totem",
  ],
  email_enabled_source_list: ["mallplaza_web"],
  rut_enabled_country_list: ["chile", "CL", "india", "IN"],
  nationalId_enabled_country_list: ["colombia", "CO"],
  curp_enabled_country_list: ["mexico", "MX"],
  dni_enabled_country_list: ["peru", "PE", "argentina", "AR", "uruguay", "UY"],
  cpf_enabled_country_list: ["brazil"],
  officeConfig: {
    bu: "officeBU",
    country: "officecountry",
    source: "msteams",
    defaultOffice: "Cowork",
  },
  preferredLocation: {
    Falabella: {
      CL: "SUR",
    },
    "Banco Falabella": {
      CL: "Región Metropolitana Poniente",
    },
  },
  multi_id_disabled_bu_list: ["Banco Falabella"],
  phoneLength: {
    CL: {
      max: 9,
      min: 9,
    },
  },
  id_alternatives: {
    CL: [
      {
        docType: "RUT",
        value: "01",
        label: "RUT",
        default: true,
        length: 8,
        validationType: "numeric",
        specificValidation: "validateRUT",
        min: 8,
        max: 9,
      },
    ],
    PE: [
      {
        docType: "DNI",
        value: "03",
        label: "DNI",
        default: true,
        length: 9,
        validationType: "numeric",
        specificValidation: "validatePEDNI",
      },
      {
        docType: "CE",
        value: "06",
        label: "Carnet Extranjería",
        default: false,
        length: 9,
        validationType: "alphanumeric",
        specificValidation: "",
      },
    ],
    AR: [
      {
        docType: "DNI",
        value: "10",
        label: "DNI",
        default: true,
        length: 8,
        validationType: "numeric",
        specificValidation: "validateARDNI",
        min: 7,
        max: 8,
      },
    ],
    CO: [
      {
        docType: "DNI",
        value: "14",
        label: "Documento de Identidad",
        default: true,
        length: 11,
        validationType: "numeric",
        specificValidation: "validateNID",
      },
      {
        docType: "passport",
        value: "15",
        label: "Pasaporte",
        default: false,
        length: 8,
        validationType: "alphanumeric",
        specificValidation: "",
      },
      {
        docType: "CE",
        value: "18",
        label: "Cedula Extranjería",
        default: false,
        length: 6,
        validationType: "numeric",
        specificValidation: "",
      },
    ],
    MX: [
      {
        docType: "telephone",
        default: true,
        value: "22",
        label: "Número de contacto",
        length: 10,
        validationType: "numeric",
        specificValidation: "validatePhoneNumber",
      },
    ],
    IN: [
      {
        docType: "RUT",
        value: "IN1",
        label: "RUT",
        default: true,
        length: 8,
        validationType: "numeric",
        specificValidation: "validateRUT",
        min: 8,
        max: 9,
      },
      {
        docType: "passport",
        default: false,
        value: "IN2",
        label: "Pasaporte",
        length: 9,
        validationType: "alphanumeric",
        specificValidation: "",
      },
    ],
    UY: [
      {
        docType: "CI",
        value: "23",
        label: "CI",
        default: true,
        length: 11,
        validationType: "alphanumeric",
        specificValidation: "validateCI",
        min: 7,
        max: 8,
      },
    ],
    BR: [
      {
        docType: "CPF",
        default: true,
        value: "28",
        label: "CPF",
        validationType: "alphanumeric",
        specificValidation: "validateCPF",
        min: 11,
        max: 11,
      },
    ],
  },
};

export default config;
